import * as Selectors from '../../../store/selectors';
import { useSelector } from '../../../store/redux';
import {
    useGetConfigurationCompatibleOptions,
    useGetConfigurationAllOptions,
} from './useGetConfigurationOptions';
import { Fixtuur } from '@fixtuur/backpack';

export const useGetCompatibleOptions = ():
    | Fixtuur.Configuration.Options.Options
    | undefined
    | null => {
    const inConfiguration = useSelector(Selectors.Initialisation.inConfiguration);

    const { compatibleConfigurationOptions } = useGetConfigurationCompatibleOptions();

    return inConfiguration ? compatibleConfigurationOptions : null;
};

export { useGetConfigurationAllOptions };
